import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { ModalHeader, ModalBody, ModalFooter } from '../styled/Modal/styles';
import { PartnerFormContainer } from './styles';

import Button from '../styled/Button';
import PartnerForm from './PartnerForm';

class PartnerEditFormModal extends Component {
    componentDidMount() {
        const { store, partner } = this.props;
        const { editPartnerForm } = store.partners;

        editPartnerForm.setValues(partner);
    }

    componentWillUnmount() {
        const { editPartnerForm } = this.props.store.partners;
        editPartnerForm.reset();
    }

    render() {
        const { editPartnerForm } = this.props.store.partners;

        return (
            <PartnerFormContainer>
                <ModalHeader>Muuda partnerit</ModalHeader>
                <ModalBody>
                    <PartnerForm id="editPartner" form={editPartnerForm} />
                </ModalBody>
                <ModalFooter borderless>
                    <Button
                        form="editPartner"
                        value="Muuda partner"
                        isLoading={editPartnerForm.isLoading}
                    />
                </ModalFooter>
            </PartnerFormContainer>
        );
    }
}

export default inject('store')(observer(PartnerEditFormModal));
